export default __webpack_public_path__ + "static/media/Statistik Lengkap UTBK STEI-K22.c1107eda.png";